import Component from "@glimmer/component";
import { hash } from "@ember/helper";
import { on } from "@ember/modifier";
import { LinkTo } from "@ember/routing";
import { service } from "@ember/service";
import { eq, or } from "truth-helpers";
import concatClass from "discourse/helpers/concat-class";
import icon from "discourse-common/helpers/d-icon";
import deprecated from "discourse-common/lib/deprecated";
import SectionLinkPrefix from "./section-link-prefix";
/**
 * Checks if a given string is a valid color hex code.
 *
 * @param {String|undefined} input Input string to check if it is a valid color hex code. Can be in the form of "FFFFFF" or "#FFFFFF" or "FFF" or "#FFF".
 * @returns {String|undefined} Returns the matching color hex code without the leading `#` if it is valid, otherwise returns undefined. Example: "FFFFFF" or "FFF".
 */
import { setComponentTemplate } from "@ember/component";
import { createTemplateFactory } from "@ember/template-factory";
export function isHex(input1) {
  const match1 = input1?.match(/^#?([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/);
  if (match1) {
    return match1[1];
  } else {
    return;
  }
}
export default class SectionLink extends Component {
  static #_ = (() => dt7948.g(this.prototype, "currentUser", [service]))();
  #currentUser = (() => (dt7948.i(this, "currentUser"), void 0))();
  constructor() {
    super(...arguments);
    this.args.didInsert?.();
  }
  willDestroy() {
    super.willDestroy(...arguments);
    this.args.willDestroy?.();
  }
  get shouldDisplay() {
    if (this.args.shouldDisplay === undefined) {
      return true;
    }
    return this.args.shouldDisplay;
  }
  get linkClass() {
    let classNames1 = ["sidebar-section-link", "sidebar-row"];
    if (this.args.linkClass) {
      classNames1.push(this.args.linkClass);
    }
    if (this.args.class) {
      deprecated("SectionLink's @class arg has been renamed to @linkClass", {
        id: "discourse.section-link-class-arg",
        since: "3.2.0.beta4",
        dropFrom: "3.3.0.beta1"
      });
      classNames1.push(this.args.class);
    }
    return classNames1.join(" ");
  }
  get target() {
    return this.currentUser?.user_option?.external_links_in_new_tab && this.isExternal ? "_blank" : "_self";
  }
  get isExternal() {
    return this.args.href && new URL(this.args.href, window.location.href).origin !== window.location.origin;
  }
  get models() {
    if (this.args.model) {
      return [this.args.model];
    }
    if (this.args.models) {
      return this.args.models;
    }
    return [];
  }
  get prefixColor() {
    const hexCode1 = isHex(this.args.prefixColor);
    if (hexCode1) {
      return `#${hexCode1}`;
    } else {
      return;
    }
  }
  static #_2 = (() => setComponentTemplate(createTemplateFactory(
  /*
    
      {{#if this.shouldDisplay}}
        <li
          data-list-item-name={{@linkName}}
          class="sidebar-section-link-wrapper"
          ...attributes
        >
          {{#if @href}}
            <a
              href={{@href}}
              rel="noopener noreferrer"
              target={{this.target}}
              title={{@title}}
              data-link-name={{@linkName}}
              class={{this.linkClass}}
            >
              <SectionLinkPrefix
                @prefixType={{@prefixType}}
                @prefixValue={{@prefixValue}}
                @prefixCSSClass={{@prefixCSSClass}}
                @prefixColor={{this.prefixColor}}
                @prefixBadge={{@prefixBadge}}
              />
  
              <span class="sidebar-section-link-content-text">
                {{@content}}
              </span>
            </a>
          {{else}}
            <LinkTo
              @route={{@route}}
              @query={{or @query (hash)}}
              @models={{this.models}}
              @current-when={{@currentWhen}}
              title={{@title}}
              data-link-name={{@linkName}}
              class={{this.linkClass}}
            >
              <SectionLinkPrefix
                @prefixType={{@prefixType}}
                @prefixValue={{@prefixValue}}
                @prefixCSSClass={{@prefixCSSClass}}
                @prefixColor={{this.prefixColor}}
                @prefixBadge={{@prefixBadge}}
              />
  
              <span
                class={{concatClass
                  "sidebar-section-link-content-text"
                  @contentCSSClass
                }}
              >
                {{@content}}
                <@contentComponent />
              </span>
  
              {{#if @badgeText}}
                <span class="sidebar-section-link-content-badge">
                  {{@badgeText}}
                </span>
              {{/if}}
  
              {{#if @suffixValue}}
                <span
                  class={{concatClass
                    "sidebar-section-link-suffix"
                    @suffixType
                    @suffixCSSClass
                  }}
                >
                  {{#if (eq @suffixType "icon")}}
                    {{icon @suffixValue}}
                  {{/if}}
                </span>
              {{/if}}
  
              {{#if @hoverValue}}
                <span class="sidebar-section-link-hover">
                  <button
                    {{on "click" @hoverAction}}
                    type="button"
                    title={{@hoverTitle}}
                    class="sidebar-section-hover-button"
                  >
                    {{#if (eq @hoverType "icon")}}
                      {{icon @hoverValue class="hover-icon"}}
                    {{/if}}
                  </button>
                </span>
              {{/if}}
            </LinkTo>
          {{/if}}
        </li>
      {{/if}}
    
  */
  {
    "id": "cQhXvzb/",
    "block": "[[[1,\"\\n\"],[41,[30,0,[\"shouldDisplay\"]],[[[1,\"      \"],[11,\"li\"],[16,\"data-list-item-name\",[30,1]],[24,0,\"sidebar-section-link-wrapper\"],[17,2],[12],[1,\"\\n\"],[41,[30,3],[[[1,\"          \"],[10,3],[15,6,[30,3]],[14,\"rel\",\"noopener noreferrer\"],[15,\"target\",[30,0,[\"target\"]]],[15,\"title\",[30,4]],[15,\"data-link-name\",[30,1]],[15,0,[30,0,[\"linkClass\"]]],[12],[1,\"\\n            \"],[8,[32,0],null,[[\"@prefixType\",\"@prefixValue\",\"@prefixCSSClass\",\"@prefixColor\",\"@prefixBadge\"],[[30,5],[30,6],[30,7],[30,0,[\"prefixColor\"]],[30,8]]],null],[1,\"\\n\\n            \"],[10,1],[14,0,\"sidebar-section-link-content-text\"],[12],[1,\"\\n              \"],[1,[30,9]],[1,\"\\n            \"],[13],[1,\"\\n          \"],[13],[1,\"\\n\"]],[]],[[[1,\"          \"],[8,[32,1],[[16,\"title\",[30,4]],[16,\"data-link-name\",[30,1]],[16,0,[30,0,[\"linkClass\"]]]],[[\"@route\",\"@query\",\"@models\",\"@current-when\"],[[30,10],[28,[32,2],[[30,11],[28,[32,3],null,null]],null],[30,0,[\"models\"]],[30,12]]],[[\"default\"],[[[[1,\"\\n            \"],[8,[32,0],null,[[\"@prefixType\",\"@prefixValue\",\"@prefixCSSClass\",\"@prefixColor\",\"@prefixBadge\"],[[30,5],[30,6],[30,7],[30,0,[\"prefixColor\"]],[30,8]]],null],[1,\"\\n\\n            \"],[10,1],[15,0,[28,[32,4],[\"sidebar-section-link-content-text\",[30,13]],null]],[12],[1,\"\\n              \"],[1,[30,9]],[1,\"\\n              \"],[8,[30,14],null,null,null],[1,\"\\n            \"],[13],[1,\"\\n\\n\"],[41,[30,15],[[[1,\"              \"],[10,1],[14,0,\"sidebar-section-link-content-badge\"],[12],[1,\"\\n                \"],[1,[30,15]],[1,\"\\n              \"],[13],[1,\"\\n\"]],[]],null],[1,\"\\n\"],[41,[30,16],[[[1,\"              \"],[10,1],[15,0,[28,[32,4],[\"sidebar-section-link-suffix\",[30,17],[30,18]],null]],[12],[1,\"\\n\"],[41,[28,[32,5],[[30,17],\"icon\"],null],[[[1,\"                  \"],[1,[28,[32,6],[[30,16]],null]],[1,\"\\n\"]],[]],null],[1,\"              \"],[13],[1,\"\\n\"]],[]],null],[1,\"\\n\"],[41,[30,19],[[[1,\"              \"],[10,1],[14,0,\"sidebar-section-link-hover\"],[12],[1,\"\\n                \"],[11,\"button\"],[16,\"title\",[30,20]],[24,0,\"sidebar-section-hover-button\"],[24,4,\"button\"],[4,[32,7],[\"click\",[30,21]],null],[12],[1,\"\\n\"],[41,[28,[32,5],[[30,22],\"icon\"],null],[[[1,\"                    \"],[1,[28,[32,6],[[30,19]],[[\"class\"],[\"hover-icon\"]]]],[1,\"\\n\"]],[]],null],[1,\"                \"],[13],[1,\"\\n              \"],[13],[1,\"\\n\"]],[]],null],[1,\"          \"]],[]]]]],[1,\"\\n\"]],[]]],[1,\"      \"],[13],[1,\"\\n\"]],[]],null],[1,\"  \"]],[\"@linkName\",\"&attrs\",\"@href\",\"@title\",\"@prefixType\",\"@prefixValue\",\"@prefixCSSClass\",\"@prefixBadge\",\"@content\",\"@route\",\"@query\",\"@currentWhen\",\"@contentCSSClass\",\"@contentComponent\",\"@badgeText\",\"@suffixValue\",\"@suffixType\",\"@suffixCSSClass\",\"@hoverValue\",\"@hoverTitle\",\"@hoverAction\",\"@hoverType\"],false,[\"if\"]]",
    "moduleName": "/var/www/discourse/app/assets/javascripts/discourse/node_modules/.embroider/rewritten-app/components/sidebar/section-link.js",
    "scope": () => [SectionLinkPrefix, LinkTo, or, hash, concatClass, eq, icon, on],
    "isStrictMode": true
  }), this))();
}